import type { CSSProperties } from "react";

export const talkRadarStageStyle: CSSProperties = {
  position: "absolute",
  inset: 0,
  overflowX: "hidden",
  overflowY: "auto",
  background: "#081018",
  color: "#e2e8f0",
  padding: "72px 16px 24px",
};

export const talkRadarDiscStyle: CSSProperties = {
  width: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
  aspectRatio: "1",
};

export const talkRadarCodeDiscStyle: CSSProperties = {
  width: "calc(100% - 80px)",
  maxWidth: "calc(100% - 80px)",
  maxHeight: "calc(100% - 80px)",
  aspectRatio: "1",
};
